const CalendarIcon = ({ className, stroke = '#9D9D9D', ...props }) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
            <path
                d="M18 4H6C3.79086 4 2 5.79086 2 8V18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18V8C22 5.79086 20.2091 4 18 4Z"
                stroke={stroke}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M8 2V6M16 2V6M2 10H22" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default CalendarIcon;
